import Joi from '@hapi/joi';
import React from 'react';
import {
    CollapsiblePanel,
    DataPanelCell,
    EditPanel,
    EditPanelButtons,
    EditPanelCell,
    EditPanelHeader,
    EditPanelRow,
    EditPanelSection,
    PanelBody,
} from '../../components/elements';
import {
    ValidatingCulturedFormInputNumber,
    ValidatingEditPanelSaveButton,
    ValidatingFilterDropdown,
    ValidatingForm,
    ValidatingFormContext,
    ValidatingFormItemDateValue,
    ValidatingFormTextArea,
} from '../../components/validatingElements';
import { useTranslate } from '../../mixins/translate/translate';
import { verificatieBerekeningSelectOptions } from './verificatieBerekeningSelectOptions';

function getConditionStyle(condition?: string) {
    if (!condition) {
        return undefined;
    } else if (condition === '1') {
        return { color: 'white', backgroundColor: '#267b45', padding: '20px' };
    }
    return { color: 'white', backgroundColor: '#d73f2d', padding: '20px' };
}

export function SurveyEditVerificatieBerekeningSummaryAndAdvice(props: { surveyId: string }) {
    const translate = useTranslate();

    async function onChange(key: any, value: any, item: any, validatingFormChange: (key: any, value: any) => Promise<void>) {
        if (key === 'inspectionStandardData.jaren') {
            const now = new Date();
            const einddatum = now.setFullYear(now.getFullYear() + (value as number));
            await validatingFormChange('inspectionStandardData', {
                ...item.inspectionStandardData,
                ...{
                    jaren: value,
                    einddatum,
                },
            });
        }
    }

    return (
        <EditPanel bottomMargin={true} noPadding={true}>
            <CollapsiblePanel heading={{ dark: true, text: 'Resultaat en restlevensduur' }}>
                <ValidatingForm
                    schema={Joi.object()}
                    itemUrl={`/api/surveys/${props.surveyId}`}
                    id={props.surveyId}
                    onChange={onChange}
                    showSavedToast
                >
                    <PanelBody isForm={true}>
                        <EditPanelHeader text="Resultaat" />

                        <EditPanelRow>
                            <EditPanelCell rowCount={4}>
                                <ValidatingFormContext.Consumer>
                                    {(state) => (
                                        <ValidatingFilterDropdown
                                            name="condition"
                                            selectOptions={verificatieBerekeningSelectOptions.toetsing}
                                            dropdownIndicatorStyle={getConditionStyle(state.item.condition)}
                                        />
                                    )}
                                </ValidatingFormContext.Consumer>
                            </EditPanelCell>
                        </EditPanelRow>
                        <EditPanelSection>
                            <ValidatingFormTextArea name="summaryAndAdvice" placeholder={translate('survey.composeSummaryAndAdvice')} size="s" />
                        </EditPanelSection>
                        <EditPanelHeader text="Restlevensduur" />
                        <EditPanelRow>
                            <EditPanelCell rowCount={3}>
                                <ValidatingCulturedFormInputNumber name="inspectionStandardData.jaren" topLabel="Jaren" />
                            </EditPanelCell>
                            <DataPanelCell rowCount={4} text="Einddatum" pt>
                                <ValidatingFormItemDateValue name="inspectionStandardData.einddatum" />{' '}
                            </DataPanelCell>
                        </EditPanelRow>

                        <EditPanelSection>
                            <ValidatingFormTextArea name="inspectionStandardData.voorwaarden" placeholder="Voorwaarden" size="s" />
                        </EditPanelSection>

                        <EditPanelButtons>
                            <ValidatingEditPanelSaveButton small={true} />
                        </EditPanelButtons>
                    </PanelBody>
                </ValidatingForm>
            </CollapsiblePanel>
        </EditPanel>
    );
}
